import { render, staticRenderFns } from "./GouwuShangquanFenxi.vue?vue&type=template&id=15b69305&scoped=true&"
import script from "./GouwuShangquanFenxi.vue?vue&type=script&lang=js&"
export * from "./GouwuShangquanFenxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b69305",
  null
  
)

export default component.exports